export const TRANSLATION_CONSTANT={
    TRANSLATION_SAVE:'TRANSLATION_SAVE',
    SEARCHED_MEMORY:'SEARCHED_MEMORY',
    SEARCHED_WAREHOUSE:"SEARCHED_WAREHOUSE"
}